import { Button, Column, GridContainer, H1, Link, Row, Span } from '@vp/swan';
import { DateFormatTypes } from '@vp/om-date-formatter';
import React, { useContext } from 'react';
import { ReplaceTokens, useTranslations } from '@vp/om-translations';
import Date from '../../shared/Date';
import useSiteData from '../../../hooks/useSiteData';
import DesignFeedbackGroupRequestContext from '../../contexts/DesignFeedbackGroupRequestContext';

export const RequestPageHeader = () => {
  const [designFeedbackMessages] = useTranslations(['designFeedbackMessages']);
  const { externalAppNavigation: nav } = useSiteData();
  const orderDetailsUrl = nav.orderDetails;
  const { orderId, deadline } = useContext(DesignFeedbackGroupRequestContext);

  return (
    <GridContainer>
      <Row>
        <Column span={12}>
          <H1 fontSize="x3large" mb={6}>
            <ReplaceTokens
              tokenizedString={designFeedbackMessages.designFeedbackHead}
              substitutions={{
                date: (
                  <Date
                    date={deadline}
                    dateFormatType={DateFormatTypes.MEDIUM_FMT}
                  />
                ),
              }}
            />
          </H1>
          <Span mb={6} fontSkin="body-standard-bold">
            {designFeedbackMessages.orderNumber}{' '}
          </Span>
          <Span mb={6}>
            <Button
              skin="link"
              render={props => (
                <Link
                  href={`${orderDetailsUrl}?orderId=${orderId}`}
                  className={props.className}
                >
                  {props.children}
                </Link>
              )}
            >
              {orderId}
            </Button>
          </Span>
        </Column>
      </Row>
    </GridContainer>
  );
};
